import AbstractView = require("./abstract/AbstractView");
import 'owl.carousel';
import HiddenLayer = require("./HiddenLayer");
import ThumbnailsCarousel = require("./ThumbnailsCarousel");


class AccessoriesView extends AbstractView {

    constructor(id: number, selector: JQuery) {
        super(id, selector);
    }

    init(): void {
        this.createTriggerBtn();
        this.createCarousel();
    }


    onScroll(containerTop: number): void {
    }

    reset(): void {
    }


    private createTriggerBtn(): void {

        let btnTotal: number = this.$template.find(".triggerBtn").length;
        for (let i: number = 0; i < btnTotal; i++) {
            let btn: JQuery = this.$template.find(".triggerBtn:eq(" + i + ")");
            btn.on("click tap", {id: i}, (event: JQuery.Event) => {
                event.preventDefault();
                // @ts-ignore
                this.changeCarousel(event.data["id"])
            });
        }
    }


    private carouselData: any[];

    private createCarousel(): void {
        this.carouselData = [
            {
                selector: ".begCon",
                carousel: ".begCarousel",
                controls: ".begControls",
                thumbnails: ".begThumbnails",
                target: null
            },
            {
                selector: ".headsetCon",
                carousel: ".headCarousel",
                controls: ".headControls",
                thumbnails: ".headThumbnails",
                target: null
            },
            {
                selector: ".mouseCon",
                carousel: ".mouseCarousel",
                controls: ".mouseControls",
                thumbnails: ".mouseThumbnails",
                target: null
            }
        ];

        for (let i: number = 0; i < this.carouselData.length; i++) {
            let targetCarousel: ThumbnailsCarousel = new ThumbnailsCarousel(
                this.$template.find(this.carouselData[i]["selector"]),
                this.getChildBySelector(this.carouselData[i]["carousel"]),
                this.getChildBySelector(this.carouselData[i]["controls"]),
                this.getChildBySelector(this.carouselData[i]["thumbnails"])
            );
            this.carouselData[i]["target"] = targetCarousel;
            targetCarousel.transitionOut();
        }
    }

    private changeCarousel(id: number): void {
        for (let i: number = 0; i < this.carouselData.length; i++) {
            let targetCon: ThumbnailsCarousel = this.carouselData[i]["target"];
            if (i == id) {
                targetCon.transitionIn();
            } else {
                targetCon.transitionOut();
            }
        }
    }


}

export = AccessoriesView;